import { configureStore, SerializedError } from '@reduxjs/toolkit';
import vulnerabilitiesReducer, {
    IVulnerabilitiesState,
} from './vulnerabilities/sliceVulnerabilities';
import userSettingsReducer, { IUserSettingsState } from './user/sliceUserSettings';
import userProfileReducer, { IUserProfileState } from './user/sliceUserProfile';

/**
 * Interface that describes an action that is run against a slice's state object.
 */
export interface IAction<T> {
    /** Action type. */
    type: string;

    /** Action payload object. */
    payload: T;

    /** (Optional) Action error object. */
    error?: SerializedError;
}

/**
 * Interface that describes the base object properties of a redux state slice that sends requests to the backend.
 */
export interface SliceProps {
    /** Whether a resource is being loaded or not. */
    loading: boolean;

    /** Error that is thrown during resource fetching. */
    error: SerializedError;
}

/**
 * Interface that describes the base object properties of a redux state slice that requests backend data.
 */
export interface SlicePropsWithData<T> extends SliceProps {
    /** Data that is fetched from the backend. */
    data: T;
}

/**
 * Interface that describes the structure of the Application Redux store.
 */
export interface IAppReduxStore {
    vulnerabilities: IVulnerabilitiesState;

    userSettings: IUserSettingsState;
    userProfile: IUserProfileState;
}

/**
 * Application Redux store.
 */
export default configureStore({
    reducer: {
        vulnerabilities: vulnerabilitiesReducer,

        userSettings: userSettingsReducer,
        userProfile: userProfileReducer,
    },
});
